import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID || "833c980a-e28f-478c-baa4-30ab2e0f5228",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_TENANT_ID || "694f2563-ba8f-4e96-bbe0-e1ee263c3088"}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:8081/auth/callback",
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_URI || (process.env.REACT_APP_REDIRECT_URI ? process.env.REACT_APP_REDIRECT_URI.replace('/auth/callback', '/login') : "http://localhost:8081/login")
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        if (level <= LogLevel.Info) {
          console.log("[MSAL]", message);
        }
      },
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read", "Mail.Send"]
};

export const tokenRequest = {
  scopes: ["User.Read"]
};
